import { render } from "./NotizCreateOrEditModal.pug?vue&type=template&id=03b4482c&lang=pug"
import script from "./NotizCreateOrEditModal.js?vue&type=script&lang=js"
export * from "./NotizCreateOrEditModal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__